const formatTime = (v) => `0${v}`.substr(-2, 2);
export function parseWildcardDates(date, currentDate) {
    const [year, month, day] = date.split('-');
    const possibleYears = (() => {
        if (year === '*') {
            const currentYear = currentDate.getFullYear();
            return [currentYear, currentYear + 1, currentYear + 2].map((y) => y.toString());
        }
        else {
            return year.split(',');
        }
    })();
    const possibleMonths = (() => {
        if (month === '*') {
            return [...Array(12)].map((_, i) => {
                return formatTime(i + 1);
            });
        }
        else {
            return month.split(',').map((month) => formatTime(month));
        }
    })();
    const getPossibleDays = (year, month) => {
        if (day === '*') {
            const daysInMonth = new Date(parseInt(year), parseInt(month), 0).getDate();
            return [...Array(daysInMonth)].map((_, i) => {
                return formatTime(i + 1);
            });
        }
        else {
            return day.split(',').map((day) => formatTime(day));
        }
    };
    const monthsYearsCombo = possibleYears.reduce((carry, year) => {
        return [
            ...carry,
            ...possibleMonths.map((month) => {
                return {
                    year,
                    month,
                };
            }),
        ];
    }, []);
    return monthsYearsCombo.reduce((carry, { year, month }) => {
        const possibleDays = getPossibleDays(year, month);
        return [...carry, ...possibleDays.map((day) => `${year}-${month}-${day}`)];
    }, []);
}
export const getDates = (db, de) => {
    const difference = new Date(de).getTime() - new Date(db).getTime();
    const numberOfDays = Math.ceil(difference / (1000 * 3600 * 24));
    if (numberOfDays < 0) {
        return [];
    }
    const curDate = new Date(db);
    return Array(numberOfDays)
        .fill(db)
        .reduce((acc) => {
        const nextDate = new Date(curDate.setDate(curDate.getDate() + 1)).toISOString().split('T')[0];
        return [...acc, nextDate];
    }, [db]);
};
